import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Service to manage global loading state.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {
  private counter = 0;
  private _loading$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loading$.asObservable();

  private minVisibleMs = 250;
  private lastShowAt = 0;
  private resetTimeout: any;

  /**
   * Shows the loading indicator.
   * Increments the loading counter.
   */
  show() {
    this.counter++;
    if (this.counter === 1) {
      this.lastShowAt = Date.now();
      this._loading$.next(true);

      // Safety timeout: force hide after 30 seconds to prevent stuck spinner
      this.resetTimeout = setTimeout(() => {
        if (this.counter > 0) {
          console.warn(`LoadingService: Forcing reset after timeout - counter was: ${this.counter}`);
          this.counter = 0;
          this._loading$.next(false);
        }
      }, 30000);
    }
  }

  /**
   * Hides the loading indicator (decrements counter).
   * Ensures minimum visibility time to avoid flickering.
   */
  hide() {
    if (this.counter > 0) this.counter--;
    if (this.counter === 0) {
      if (this.resetTimeout) {
        clearTimeout(this.resetTimeout);
        this.resetTimeout = null;
      }
      const delta = Date.now() - this.lastShowAt;
      const wait = Math.max(0, this.minVisibleMs - delta);
      setTimeout(() => {
        this._loading$.next(false);
      }, wait);
    }
  }

  /**
   * Forces a reset of the loading state.
   */
  reset() {
    this.counter = 0;
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
      this.resetTimeout = null;
    }
    this._loading$.next(false);
  }
}
